module.exports = __webpack_public_path__ + "img/square-edit-outline.8248b2e2.svg";